import { Stack, Box, Typography } from "@mui/material";
import { info, error, success, warning } from "../../../../theme/colors";
export var CalendarLegend = function () { /*#__PURE__*/ return React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    flexGrow: 1,
    gap: 2,
    fontSize: "sm",
    color: "text.secondary"
}, /*#__PURE__*/ React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    gap: 0.5
}, /*#__PURE__*/ React.createElement(Box, {
    borderRadius: 1,
    width: 16,
    sx: {
        aspectRatio: '1/1',
        backgroundColor: info[300]
    }
}), /*#__PURE__*/ React.createElement(Typography, {
    fontSize: "inherit"
}, "less than 25%")), /*#__PURE__*/ React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    gap: 0.5
}, /*#__PURE__*/ React.createElement(Box, {
    borderRadius: 1,
    width: 16,
    sx: {
        aspectRatio: '1/1',
        backgroundColor: success[300]
    }
}), /*#__PURE__*/ React.createElement(Typography, {
    fontSize: "inherit"
}, "25% to 50%")), /*#__PURE__*/ React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    gap: 0.5
}, /*#__PURE__*/ React.createElement(Box, {
    borderRadius: 1,
    width: 16,
    sx: {
        aspectRatio: '1/1',
        backgroundColor: warning[300]
    }
}), /*#__PURE__*/ React.createElement(Typography, {
    fontSize: "inherit"
}, "50% to 75%")), /*#__PURE__*/ React.createElement(Stack, {
    direction: "row",
    alignItems: "center",
    gap: 0.5
}, /*#__PURE__*/ React.createElement(Box, {
    borderRadius: 1,
    width: 16,
    sx: {
        aspectRatio: '1/1',
        backgroundColor: error[300]
    }
}), /*#__PURE__*/ React.createElement(Typography, {
    fontSize: "inherit"
}, "more than 75%"))); };
